import { times } from "@/math/coordinates";
import { zoomFactor } from "@/model/Settings";
import type { CardSize } from "@/model/board";

export function cardSizeFrom(value: { factor: number }): CardSize;
export function cardSizeFrom(value: { cardWidth: number; boardWidth: number }): CardSize;
export function cardSizeFrom(value: {
  factor?: number;
  cardWidth?: number;
  boardWidth?: number;
}): CardSize {
  if (value.factor !== undefined) {
    return { factor: value.factor, ...times(zoomFactor, value.factor) };
  }
  return cardSizeFrom({ factor: value.cardWidth! / value.boardWidth! / zoomFactor.x });
}
